export default __webpack_public_path__ + "static/media/birthday-partner-plan.e5e10423.svg";